module.exports = __webpack_public_path__ + "ff016a520d10ee1200153dc24400b253.png";